module.exports = __webpack_public_path__ + "static/media/table_pelanggaran.c7711c9d.png";